/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractFileSearchResult } from './APIContractFileSearchResult';
import {
    APIContractFileSearchResultFromJSON,
    APIContractFileSearchResultFromJSONTyped,
    APIContractFileSearchResultToJSON,
} from './APIContractFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIContractFileSearchResponse
 */
export interface APIContractFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIContractFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIContractFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIContractFileSearchResult>}
     * @memberof APIContractFileSearchResponse
     */
    results: Array<APIContractFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIContractFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIContractFileSearchResponse interface.
 */
export function instanceOfAPIContractFileSearchResponse(value: object): value is APIContractFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIContractFileSearchResponseFromJSON(json: any): APIContractFileSearchResponse {
    return APIContractFileSearchResponseFromJSONTyped(json, false);
}

export function APIContractFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIContractFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIContractFileSearchResponseToJSON(value?: APIContractFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIContractFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

